import React, { useCallback, useEffect, useMemo, useState } from "react";
import { CheckboxAccordionItem } from "components/_Modals/ProjectDownloadModal/ReportsCheckboxes/CheckboxAccordionItem";
import {
  findItemById,
  updateItemSelection,
} from "components/_Modals/ProjectDownloadModal/ReportsCheckboxes/helpers";
import type {
  CheckboxAccordionItemProps,
  ReportNodeType,
} from "components/_Modals/ProjectDownloadModal/ReportsCheckboxes/types";

export const ReportsCheckBoxes: React.FC<CheckboxAccordionItemProps> =
  React.memo(
    ({
      blockTitle,
      updateItemSelectionRef,
      initialData,
      handleChangeSelectedCount,
      expandedAccordionIds,
      setExpandedAccordionIds,
      projectId,
    }) => {
      const [items, setItems] = useState<ReportNodeType[]>(initialData);

      useEffect(() => {
        if (updateItemSelectionRef) {
          updateItemSelectionRef.current = {
            updateItems: (targetId: string, selected: boolean) =>
              setItems((prevItems) =>
                updateItemSelection(
                  prevItems,
                  targetId,
                  selected,
                  handleChangeSelectedCount,
                ),
              ),
            getCurrentItems: () => items,
          };
        }
      }, [handleChangeSelectedCount, items, updateItemSelectionRef]);

      const handleToggle = useCallback(
        (id: string) => {
          setItems((prevItems) => {
            const targetItem = findItemById(prevItems, id);
            if (!targetItem) {
              return prevItems;
            }

            const newSelected = !targetItem.selected;
            return updateItemSelection(
              prevItems,
              id,
              newSelected,
              handleChangeSelectedCount,
            );
          });
        },
        [handleChangeSelectedCount],
      );

      const renderedItems = useMemo(
        () =>
          items.map((item) => (
            <CheckboxAccordionItem
              key={item.id}
              item={item}
              onToggle={handleToggle}
              expandedAccordionIds={expandedAccordionIds}
              setExpandedAccordionIds={setExpandedAccordionIds}
              projectId={projectId}
            />
          )),
        [
          items,
          handleToggle,
          expandedAccordionIds,
          setExpandedAccordionIds,
          projectId,
        ],
      );

      return (
        <div className="flex-xs-column d-flex">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h3 className="text-uppercase mb-0 font20">{blockTitle}</h3>
          </div>
          {renderedItems}
        </div>
      );
    },
  );
